<template>
  <div>
    <b-navbar
      :fixed-top="true"
      :mobile-burger="isMobile"
      type="is-info"
      :shadow="true"
      class="pl-2 pr-2 mb-0"
    >
      <template #brand>
        <b-navbar-item tag="router-link" :to="{ path: '/schedule' }">
          <!-- <img src="./../assets/logo_w.png" alt="partner.nf" /> -->
          <span class="has-text-white-ter is-size-4 has-text-weight-bold">{{
            partner.nf
          }}</span>
        </b-navbar-item>
      </template>

      <template #start>
        <b-navbar-item tag="router-link" :to="{ path: '/schedule' }">
          <b-icon icon="calendar"> </b-icon> Agenda
        </b-navbar-item>

        <b-navbar-item class="queue" @click.prevent="toggleQueue()" tag="a">
          Sala de Espera
          <b-tag v-show="totalWaiting > 0" type="is-warning" rounded>{{
            totalWaiting
          }}</b-tag>
        </b-navbar-item>

        <!--<b-navbar-item tag="router-link" :to="{ path: '/chat' }">
        <b-icon icon="television"> </b-icon> Chat
      </b-navbar-item>-->
      </template>

      <template #end>
        <BillingWhatsapp
          v-show="user.role == 'doctor'"
          :maxMsgSend="user.maxMsgSend"
        />

        <b-navbar-item
          v-if="user.role == 'doctor'"
          tag="router-link"
          :to="{ path: '/setting/office' }"
        >
          <b-icon icon="doctor"> </b-icon> Configuração
        </b-navbar-item>

        <!-- <b-navbar-item
          v-show="user.role != 'doctor'"
          tag="router-link"
          :to="{ path: '/setting/attendants' }"
        >
          <b-icon icon="television"> </b-icon> Atendentes
        </b-navbar-item>
        <b-navbar-item
          v-show="user.role != 'doctor'"
          tag="router-link"
          :to="{ path: '/setting/clinic' }"
        >
          <b-icon icon="television"> </b-icon> Clínica
        </b-navbar-item> -->

        <b-navbar-item tag="div">
          <svg
            v-show="isConnected"
            class="has-text-success"
            style="width: 24px; height: 24px"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12 10C10.9 10 10 10.9 10 12S10.9 14 12 14 14 13.1 14 12 13.1 10 12 10M18 12C18 8.7 15.3 6 12 6S6 8.7 6 12C6 14.2 7.2 16.1 9 17.2L10 15.5C8.8 14.8 8 13.5 8 12.1C8 9.9 9.8 8.1 12 8.1S16 9.9 16 12.1C16 13.6 15.2 14.9 14 15.5L15 17.2C16.8 16.2 18 14.2 18 12M12 2C6.5 2 2 6.5 2 12C2 15.7 4 18.9 7 20.6L8 18.9C5.6 17.5 4 14.9 4 12C4 7.6 7.6 4 12 4S20 7.6 20 12C20 15 18.4 17.5 16 18.9L17 20.6C20 18.9 22 15.7 22 12C22 6.5 17.5 2 12 2Z"
            />
          </svg>
          <svg
            v-show="!isConnected"
            class="has-text-danger"
            style="width: 24px; height: 24px"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M17.6 14.2C17.9 13.5 18 12.8 18 12C18 8.7 15.3 6 12 6C11.2 6 10.4 6.2 9.8 6.4L11.4 8H12C14.2 8 16 9.8 16 12C16 12.2 16 12.4 15.9 12.6L17.6 14.2M12 4C16.4 4 20 7.6 20 12C20 13.4 19.6 14.6 19 15.7L20.5 17.2C21.4 15.7 22 13.9 22 12C22 6.5 17.5 2 12 2C10.1 2 8.3 2.5 6.8 3.5L8.3 5C9.4 4.3 10.6 4 12 4M3.3 2.5L2 3.8L4.1 5.9C2.8 7.6 2 9.7 2 12C2 15.7 4 18.9 7 20.6L8 18.9C5.6 17.5 4 14.9 4 12C4 10.2 4.6 8.6 5.5 7.3L7 8.8C6.4 9.7 6 10.8 6 12C6 14.2 7.2 16.1 9 17.2L10 15.5C8.8 14.8 8 13.5 8 12.1C8 11.5 8.2 10.9 8.4 10.3L10 11.9V12.1C10 13.2 10.9 14.1 12 14.1H12.2L19.7 21.6L21 20.3L4.3 3.5L3.3 2.5Z"
            />
          </svg>
          <span class="ml-2">{{ user.name }}</span>
        </b-navbar-item>

        <b-navbar-item tag="a" @click.prevent="logout()">
          <b-icon icon="power"> </b-icon>Sair</b-navbar-item
        >
      </template>

      <template #burger>
        <b-navbar-item class="queue" @click.prevent="toggleQueue()" tag="a">
          Sala de Espera
          <b-tag v-show="totalWaiting" type="is-warning" rounded>{{
            totalWaiting
          }}</b-tag>
        </b-navbar-item>

        <b-navbar-item tag="div">
          <svg
            v-show="isConnected"
            class="has-text-success"
            style="width: 24px; height: 24px"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M12 10C10.9 10 10 10.9 10 12S10.9 14 12 14 14 13.1 14 12 13.1 10 12 10M18 12C18 8.7 15.3 6 12 6S6 8.7 6 12C6 14.2 7.2 16.1 9 17.2L10 15.5C8.8 14.8 8 13.5 8 12.1C8 9.9 9.8 8.1 12 8.1S16 9.9 16 12.1C16 13.6 15.2 14.9 14 15.5L15 17.2C16.8 16.2 18 14.2 18 12M12 2C6.5 2 2 6.5 2 12C2 15.7 4 18.9 7 20.6L8 18.9C5.6 17.5 4 14.9 4 12C4 7.6 7.6 4 12 4S20 7.6 20 12C20 15 18.4 17.5 16 18.9L17 20.6C20 18.9 22 15.7 22 12C22 6.5 17.5 2 12 2Z"
            />
          </svg>
          <svg
            v-show="!isConnected"
            class="has-text-danger"
            style="width: 24px; height: 24px"
            viewBox="0 0 24 24"
          >
            <path
              fill="currentColor"
              d="M17.6 14.2C17.9 13.5 18 12.8 18 12C18 8.7 15.3 6 12 6C11.2 6 10.4 6.2 9.8 6.4L11.4 8H12C14.2 8 16 9.8 16 12C16 12.2 16 12.4 15.9 12.6L17.6 14.2M12 4C16.4 4 20 7.6 20 12C20 13.4 19.6 14.6 19 15.7L20.5 17.2C21.4 15.7 22 13.9 22 12C22 6.5 17.5 2 12 2C10.1 2 8.3 2.5 6.8 3.5L8.3 5C9.4 4.3 10.6 4 12 4M3.3 2.5L2 3.8L4.1 5.9C2.8 7.6 2 9.7 2 12C2 15.7 4 18.9 7 20.6L8 18.9C5.6 17.5 4 14.9 4 12C4 10.2 4.6 8.6 5.5 7.3L7 8.8C6.4 9.7 6 10.8 6 12C6 14.2 7.2 16.1 9 17.2L10 15.5C8.8 14.8 8 13.5 8 12.1C8 11.5 8.2 10.9 8.4 10.3L10 11.9V12.1C10 13.2 10.9 14.1 12 14.1H12.2L19.7 21.6L21 20.3L4.3 3.5L3.3 2.5Z"
            />
          </svg>
        </b-navbar-item>

        <b-navbar-item tag="a" @click.prevent="logout()">
          <b-icon icon="power"> </b-icon>Sair</b-navbar-item
        >
      </template>
    </b-navbar>
  </div>
</template>
<script>
import BillingWhatsapp from "./../components/BillingWhatsapp.vue";
import isMobile from "../services/isMobile";
export default {
  name: "NavBar",
  components: { BillingWhatsapp },
  data() {
    return {
      queueState: false,
    };
  },
  computed: {
    partner() {
      return this.$store.getters.partner;
    },
    user() {
      return this.$store.getters.user;
    },
    queue() {
      return this.$store.getters.queue;
    },
    totalWaiting() {
      if (!this.queue) return [];
      return this.queue.filter((f) => f.queueStatus == "waiting").length;
    },
    isConnected() {
      //defined in App.vue
      return this.$store.getters.isConnected;
    },
    isMobile() {
      return isMobile();
    },
  },
  methods: {
    toggleQueue() {
      this.$emit("toggleQueue", this.queueState);
    },
    logout() {
      this.$socket.emit("logout", {
        user: this.user._id,
      });
      this.$store.commit("user");
      this.$store.commit("calendarParams");
      let uriLogin = "/#/auth";
      if (this.partner.slug) uriLogin = `${uriLogin}/${this.partner.slug}`;
      window.location.replace(uriLogin);
    },
  },
};
</script>